// import React, { useMemo, useCallback } from 'react';
// import {
// 	Box,
// 	Typography,
// 	Card,
// 	CardContent,
// 	useTheme,
// 	Avatar,
// 	useMediaQuery,
// 	Grid,
// } from '@mui/material';
// import StarIcon from '@mui/icons-material/Star';
// import { Swiper, SwiperSlide } from 'swiper/react';
// import { Autoplay, Navigation, Pagination } from 'swiper/modules';
// import 'swiper/css';
// import 'swiper/css/navigation';
// import 'swiper/css/pagination';

// interface Testimonial {
// 	id: number;
// 	name: string;
// 	title?: string;
// 	comment: string;
// 	rating: number;
// 	avatar: string;
// }

// const TestimonialSlider: React.FC = () => {
// 	const theme = useTheme();
// 	const isMobile = useMediaQuery(theme.breakpoints.down('md'));

// 	const testimonials: Testimonial[] = [
// 		{
// 			id: 1,
// 			name: 'John Brown & Harvey',
// 			comment:
// 				'The food was absolutely delicious, and they worked with attention to the aroma of each ingredient to bring out the flavors. Highly recommend for any event!',
// 			rating: 5,
// 			avatar: '/testimonials/john-harvey.jpg',
// 		},
// 		{
// 			id: 2,
// 			name: 'Sarah Miller',
// 			title: 'Food Blogger',
// 			comment:
// 				'From personalization to taste, everything was perfect! The cooking recipe is an interactive menu made more special. Everything looked vegan-friendly!',
// 			rating: 5,
// 			avatar: '/testimonials/sarah.jpg',
// 		},
// 		{
// 			id: 3,
// 			name: 'David Chen',
// 			title: 'Corporate Client',
// 			comment:
// 				"Exceptional service for our company event. The menu was tailored perfectly to our diverse team's dietary needs. Will book again!",
// 			rating: 5,
// 			avatar: '/testimonials/david.jpg',
// 		},
// 		{
// 			id: 4,
// 			name: 'Sathish Rajendran',
// 			// title: 'Wedding Planner',
// 			comment: `Good catering service that's located in avadi`,
// 			rating: 5,
// 			avatar: '/testimonials/emily.jpg',
// 		},
// 		{
// 			id: 6,
// 			name: 'Jai S',
// 			// title: 'Wedding Planner',
// 			comment: `Food was delicious I went to the function recently there I have tasted the food. Sweets 5 varieties and veg Biryani was sooooo Good`,
// 			rating: 5,
// 			avatar: '/testimonials/emily.jpg',
// 		},
// 		{
// 			id: 5,
// 			name: 'John Paul',
// 			// title: 'Wedding Planner',
// 			comment: `Good catering service and the food was delicious`,
// 			rating: 5,
// 			avatar: '/testimonials/emily.jpg',
// 		},
// 	];

// 	const testimonialPairs = useMemo(() => {
// 		const pairs = [];
// 		for (let i = 0; i < testimonials.length; i += 2) {
// 			pairs.push(testimonials.slice(i, i + 2));
// 		}
// 		return pairs;
// 	}, [testimonials]);

// 	const renderStars = useCallback(
// 		(count: number) =>
// 			Array.from({ length: count }, (_, i) => (
// 				<StarIcon key={i} sx={{ color: '#F7A032', fontSize: '1.2rem' }} />
// 			)),
// 		[]
// 	);

// 	return (
// 		<Box
// 			sx={{
// 				backgroundImage: 'url("/events/Frame 1000004215.png")',
// 				backgroundSize: 'cover',
// 				backgroundPosition: 'center',
// 				position: 'relative',
// 				display: 'flex',
// 				alignItems: 'center',
// 			}}
// 		>
// 			<Box
// 				sx={{
// 					position: 'relative',
// 					zIndex: 2,
// 					width: '100%',
// 					py: 3,
// 					px: isMobile ? 2 : 4,
// 				}}
// 			>
// 				<Typography
// 					sx={{ color: 'white' }}
// 					variant="body1"
// 					align="center"
// 					gutterBottom
// 					style={{ height: '1.5rem' }}
// 					fontWeight={700}
// 				>
// 					<Typography
// 						variant="overline"
// 						style={{ marginBottom: 'auto', marginTop: 'auto', fontWeight: 800 }}
// 					>
// 						-
// 					</Typography>{' '}
// 					<span style={{ fontWeight: '300' }}>Our Testimonials</span>{' '}
// 					<Typography
// 						variant="overline"
// 						style={{ marginBottom: 'auto', marginTop: 'auto', fontWeight: 800 }}
// 					>
// 						-
// 					</Typography>
// 				</Typography>

// 				<Typography
// 					variant="h4"
// 					component="h4"
// 					sx={{
// 						color: 'white',
// 						textAlign: 'center',
// 						mb: 6,
// 						fontSize: isMobile ? '1.25rem' : '1.5rem',
// 					}}
// 				>
// 					What Our Customers Say!
// 				</Typography>

// 				<Box
// 					sx={{
// 						maxWidth: '1400px',
// 						mx: 'auto',
// 						overflow: 'hidden',
// 					}}
// 				>
// 					<Swiper
// 						spaceBetween={30}
// 						centeredSlides={true}
// 						slidesPerView={1} // Ensure only one slide is visible at a time
// 						slidesPerGroup={1} // Ensure the Swiper moves one slide at a time
// 						autoplay={{
// 							delay: 4000,
// 							disableOnInteraction: false,
// 						}}
// 						pagination={{
// 							clickable: true,
// 						}}
// 						navigation={true}
// 						modules={[Autoplay, Pagination, Navigation]}
// 						className="mySwiper"
// 					>
// 						{testimonialPairs.map((pair, index) => (
// 							<SwiperSlide key={index} style={{ height: '320px' }}>
// 								<Grid container spacing={4} justifyContent="center">
// 									{pair.map((testimonial) => (
// 										<Grid size={{ md: 5, sm: 12, xs: 12 }} key={testimonial.id}>
// 											<Card
// 												sx={{
// 													backgroundColor: 'rgba(255,255,255,0.9)',
// 													color: theme.palette.text.primary,
// 													borderRadius: 4,
// 													// boxShadow: 6,
// 													textAlign: 'center',
// 													display: 'flex',
// 													flexDirection: 'column',
// 													height: '300px',
// 												}}
// 											>
// 												<CardContent sx={{ flexGrow: 1 }}>
// 													<Box display="flex">
// 														<Box mr={2}>
// 															<Avatar
// 																src={testimonial.avatar}
// 																sx={{
// 																	width: 100,
// 																	height: 100,
// 																	mx: 'auto',
// 																	mb: 3,
// 																	border: `3px solid ${theme.palette.primary.main}`,
// 																}}
// 															/>
// 														</Box>
// 														<Box
// 															display="flex"
// 															flexDirection="column"
// 															justifyContent="center"
// 															textAlign="left"
// 														>
// 															<Typography
// 																variant="subtitle2"
// 																sx={{
// 																	mb: 1,
// 																	fontWeight: 'bold',
// 																	color: 'dark',
// 																}}
// 															>
// 																{testimonial.name}
// 															</Typography>
// 															{testimonial.title && (
// 																<Typography
// 																	color="primary"
// 																	variant="subtitle2"
// 																	sx={{ mb: 2 }}
// 																>
// 																	{testimonial.title}
// 																</Typography>
// 															)}
// 														</Box>
// 													</Box>

// 													<Typography
// 														color="secondary"
// 														variant="subtitle2"
// 														sx={{
// 															mb: 3,
// 															fontStyle: 'italic',
// 															lineHeight: 1.6,
// 														}}
// 													>
// 														{`"${testimonial.comment}"`}
// 													</Typography>

// 													<Box sx={{ mb: 2 }}>
// 														{renderStars(testimonial.rating)}
// 													</Box>
// 												</CardContent>
// 											</Card>
// 										</Grid>
// 									))}
// 								</Grid>
// 							</SwiperSlide>
// 						))}
// 					</Swiper>
// 				</Box>
// 			</Box>
// 		</Box>
// 	);
// };

// export default TestimonialSlider;
// ==============================================================================================================
// ==============================================================================================================
// ==============================================================================================================
// ==============================================================================================================
// ==============================================================================================================
// ==============================================================================================================
// ==============================================================================================================
// ==============================================================================================================
// ==============================================================================================================
// ==============================================================================================================
// ==============================================================================================================
// ==============================================================================================================
import React, { useCallback } from 'react';
import { Box, Typography, Card, CardContent, useTheme, Avatar } from '@mui/material';
import StarIcon from '@mui/icons-material/Star';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Navigation, Pagination } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

interface Testimonial {
	id: number;
	name: string;
	title?: string;
	comment: string;
	rating: number;
	avatar: string;
}

const TestimonialSlider: React.FC = () => {
	const theme = useTheme();
	// const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
	const testimonials: Testimonial[] = [
		{
			id: 1,
			name: 'Komal Parasuraman',
			comment:
				'The food was absolutely delicious, and they worked with attention to the aroma of each ingredient to bring out the flavors. Highly recommend for any event!',
			rating: 5,
			avatar: '/testimonials/john-harvey.jpg',
		},
		{
			id: 2,
			name: 'Rajeshwari',
			// title: 'Food Blogger',
			comment:
				'From personalization to taste, everything was perfect! The cooking recipe is an interactive menu made more special. Everything looked vegan-friendly!',
			rating: 5,
			avatar: '/testimonials/sarah.jpg',
		},
		{
			id: 3,
			name: 'GopalaKrishnan',
			// title: 'Corporate Client',
			comment:
				"Exceptional service for our company event. The menu was tailored perfectly to our diverse team's dietary needs. Will book again!",
			rating: 5,
			avatar: '/testimonials/david.jpg',
		},
		{
			id: 4,
			name: 'Sathish Rajendran',
			comment: `Good catering service that's located in avadi`,
			rating: 5,
			avatar: '/testimonials/emily.jpg',
		},
		{
			id: 6,
			name: 'Jai S',
			comment: `Food was delicious I went to the function recently there I have tasted the food. Sweets 5 varieties and veg Biryani was sooooo Good`,
			rating: 5,
			avatar: '/testimonials/emily.jpg',
		},
		{
			id: 5,
			name: 'John Paul',
			comment: `Good catering service and the food was delicious`,
			rating: 5,
			avatar: '/testimonials/emily.jpg',
		},
		{
			id: 5,
			name: 'Kavitha Sivaprakasam',
			comment: `Great experience! Very responsive, professional, and delivered excellent quality and value. Highly recommend!`,
			rating: 5,
			avatar: '/testimonials/emily.jpg',
		},
	];

	const renderStars = useCallback(
		(count: number) =>
			Array.from({ length: count }, (_, i) => (
				<StarIcon key={i} sx={{ color: '#F7A032', fontSize: '1.2rem' }} />
			)),
		[]
	);

	return (
		<Box
			sx={{
				backgroundImage: 'url("/events/Frame 1000004215.png")',
				backgroundSize: 'cover',
				backgroundPosition: 'center',
				position: 'relative',
				display: 'flex',
				alignItems: 'center',
			}}
		>
			<Box
				sx={{
					position: 'relative',
					zIndex: 2,
					width: '100%',
					py: 3,
					px: 2,
				}}
			>
				<Typography
					sx={{ color: 'white' }}
					variant="body1"
					align="center"
					gutterBottom
					style={{ height: '1.5rem' }}
					fontWeight={700}
				>
					<Typography
						variant="overline"
						style={{ marginBottom: 'auto', marginTop: 'auto', fontWeight: 800 }}
					>
						-
					</Typography>{' '}
					<span style={{ fontWeight: '300' }}>Our Testimonials</span>{' '}
					<Typography
						variant="overline"
						style={{ marginBottom: 'auto', marginTop: 'auto', fontWeight: 800 }}
					>
						-
					</Typography>
				</Typography>

				<Typography
					variant="h4"
					component="h4"
					sx={{
						color: 'white',
						textAlign: 'center',
						mb: 6,
						fontSize: '1.5rem',
					}}
				>
					What Our Customers Say!
				</Typography>

				<Box
					sx={{
						maxWidth: '1400px',
						mx: 'auto',
						overflow: 'hidden',
					}}
				>
					{/* <Grid
						container
						justifyContent="center"
						alignItems="center"
						style={{ width: '100%' }}
					>
						<Grid size={{ xs: 12, md: 10, lg: 8 }}> */}
					<Swiper
						spaceBetween={30}
						// centeredSlides={true}
						slidesPerView={1} // Default to 1 slide per view
						slidesPerGroup={1} // Ensure the Swiper moves one slide at a time
						autoplay={{
							delay: 4000,
							disableOnInteraction: false,
							pauseOnMouseEnter: true, // Pause autoplay on mouse enter
						}}
						// slidesPerView={isMobile ? 1 : 2}
						pagination={{
							clickable: true,
						}}
						navigation={true}
						modules={[Autoplay, Pagination, Navigation]}
						className="mySwiper"
						style={{ width: '100%' }}
						breakpoints={{
							// Define responsive breakpoints
							600: {
								slidesPerView: 1, // 1 slide per view for small screens
							},
							900: {
								slidesPerView: 2, // 2 slides per view for medium screens
							},
							1200: {
								slidesPerView: 2, // 3 slides per view for large screens
							},
						}}
					>
						{testimonials.map((testimonial) => (
							<SwiperSlide key={testimonial.id} style={{ height: '320px' }}>
								<Card
									sx={{
										// backgroundColor: 'rgba(255,255,255,0.9)',
										backgroundColor: '#fff',
										color: theme.palette.text.primary,
										borderRadius: 4,
										textAlign: 'center',
										display: 'flex',
										flexDirection: 'column',
										height: '300px',
									}}
								>
									<CardContent sx={{ flexGrow: 1 }}>
										<Box display="flex">
											<Box mr={2}>
												<Avatar
													src={testimonial.avatar}
													sx={{
														width: 100,
														height: 100,
														mx: 'auto',
														mb: 3,
														border: `3px solid ${theme.palette.primary.main}`,
													}}
												/>
											</Box>
											<Box
												display="flex"
												flexDirection="column"
												justifyContent="center"
												textAlign="left"
											>
												<Typography
													variant="subtitle2"
													sx={{
														mb: 1,
														fontWeight: 'bold',
														color: 'dark',
													}}
												>
													{testimonial.name}
												</Typography>
												{testimonial.title && (
													<Typography
														color="primary"
														variant="subtitle2"
														sx={{ mb: 2 }}
													>
														{testimonial.title}
													</Typography>
												)}
											</Box>
										</Box>

										<Typography
											color="secondary"
											variant="subtitle2"
											sx={{
												mb: 3,
												fontStyle: 'italic',
												lineHeight: 1.6,
											}}
										>
											{`"${testimonial.comment}"`}
										</Typography>

										<Box sx={{ mb: 2 }}>{renderStars(testimonial.rating)}</Box>
									</CardContent>
								</Card>
							</SwiperSlide>
						))}
					</Swiper>
					{/* </Grid>
					</Grid> */}
				</Box>
			</Box>
		</Box>
	);
};

export default TestimonialSlider;
